import { useCallback, useSyncExternalStore } from 'react';

import { getWidgetViewedAt, subscribeWidgetViewed } from '../lib/widgetViewedStore';

// Live view of the widgetViewedStore for one widget: re-renders when any tab
// marks the widget viewed. Returns epoch seconds or null (never viewed).
export function useWidgetViewedAt(widgetId) {
  const getSnapshot = useCallback(() => getWidgetViewedAt(widgetId), [widgetId]);

  return useSyncExternalStore(subscribeWidgetViewed, getSnapshot);
}
